// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Mail: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 54 42"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M54 13.543v25.27A3.185 3.185 0 0150.795 42H3.205A3.185 3.185 0 010 38.813v-25.27l22.85 16.22a7.1 7.1 0 004.134 1.339 6.957 6.957 0 004.134-1.339L54 13.543zM50.795 0C52.558 0 54 1.434 54 3.187v6.15L29.131 26.959a3.623 3.623 0 01-4.262 0L-.001 9.337v-6.15C0 1.434 1.443 0 3.206 0h47.59z"
            />
        </svg>
    );
};

export default React.memo(Mail);
